import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs';
import useTheme from '../../../utilities/hooks/theme';
import React from 'react';
import { Card } from '../../../component';
interface Props {
  onChangeTab?: any;
  activeTab?: number;
  routes?: any;
}
const MatchTabBar = ({ onChangeTab, activeTab, routes = [] }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  return (
    <Card>
      <Tabs
        TabIndicatorProps={{ style: { background: 'transparent' } }}
        onChange={onChangeTab}
        value={activeTab}
        style={{
          minHeight: 0,
          padding: 0
        }}>
        {routes.map((item: any, index: any) => {
          const { key, title } = item;
          const isActive = activeTab === index;
          return (
            <Tab
              key={key}
              style={{
                flex: 1,
                minHeight: 0,
                padding: 0,
                fontSize: '1.15rem',
                backgroundColor: theme.GLLeaderBoardSubTabBG,
                fontFamily: isActive ? 'ProximaNova-Bold' : 'ProximaNova-Regular',
                color: isActive
                  ? theme.GLLeaderBoardSubTabActiveTitle
                  : theme.GLLeaderBoardSubTabInActiveTitle,
                textTransform: 'none',
                height: '45px'
              }}
              label={`${title}`}
              value={index}
            />
          );
        })}
      </Tabs>
    </Card>
  );
};
export default React.memo(MatchTabBar);
